import i18n from "shared/i18n";

const validate = (values) => {
  const errors = {};

  if (!values.email) {
    errors.email = i18n.t("Email is required");
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,24}$/i.test(values.email)) {
    errors.email = i18n.t("Invalid email address");
  }

  if (!values.password) {
    errors.password = i18n.t("Password is required");
  }

  return errors;
};

export default validate;
